/* global google */ // Declare google as a global variable for ESLint

import React, { useEffect, useState } from "react";
import './GoogleTrafficMap.css';

const GoogleTrafficMap = ({ deviceLat, deviceLng, userLat, userLng }) => {
  const [eta, setEta] = useState(""); // State to hold the ETA in hh:mm:ss format

  useEffect(() => {
    // Load the Google Maps script dynamically
    const script = document.createElement("script");
    script.src = `https://maps.google.com/maps/api/js?key=AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg&callback=initMap&v=3`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Initialize the map and markers once the script is loaded
    window.initMap = () => {
      // Initialize the map
      const mapInstance = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 22.5937, lng: 78.9629 }, // Coordinates for India (default center)
        zoom: 5,
        mapTypeId: "roadmap", // Use roadmap view
        disableDefaultUI: true, // Remove default UI controls
        tilt: 0, // Set tilt to 0 for no 3D effect
      });

      // Add event listener for map rotation
      const trafficLayer = new google.maps.TrafficLayer();
      trafficLayer.setMap(mapInstance);

      // Directions Service and Renderer to calculate and display the route
      const directionsService = new google.maps.DirectionsService();
      const directionsRenderer = new google.maps.DirectionsRenderer({
        polylineOptions: {
          strokeColor: "#0000FF", // Blue color for the route
          strokeOpacity: 1.0,
          strokeWeight: 4, // Line width
        },
        map: mapInstance,
      });

      // Create a marker for the device (vehicle)
      if (deviceLat && deviceLng) {
        // eslint-disable-next-line
        const deviceMarker = new google.maps.Marker({
          position: { lat: deviceLat, lng: deviceLng },
          map: mapInstance,
          title: "Device Location",
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: "#ff0000", // Red for vehicle
            fillOpacity: 1,
            strokeColor: "#ff0000",
            strokeWeight: 2,
            scale: 10, // Change size of the marker
          },
        });
      }

      // Create a marker for the user
      if (userLat && userLng) {
        // eslint-disable-next-line
        const userMarker = new google.maps.Marker({
          position: { lat: userLat, lng: userLng },
          map: mapInstance,
          title: "User Location",
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: "#0000ff", // Blue for user
            fillOpacity: 1,
            strokeColor: "#0000ff",
            strokeWeight: 2,
            scale: 10, // Change size of the marker
          },
        });
      }

      // Request to calculate and display the route
      const routeRequest = {
        origin: { lat: deviceLat, lng: deviceLng },
        destination: { lat: userLat, lng: userLng },
        travelMode: google.maps.TravelMode.DRIVING, // Change to WALKING or BICYCLING if needed
      };

      // Calculate and render the route
      directionsService.route(routeRequest, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          directionsRenderer.setDirections(result);

          // Extract ETA (duration) from the result
          const durationInSeconds = result.routes[0].legs[0].duration.value; // Duration in seconds
          
          // Convert seconds to hh:mm:ss format
          const hours = Math.floor(durationInSeconds / 3600);
          const minutes = Math.floor((durationInSeconds % 3600) / 60);
          const seconds = durationInSeconds % 60;

          // Format the ETA as hh:mm:ss
          const formattedETA = `${hours > 9 ? hours : '0' + hours}:${minutes > 9 ? minutes : '0' + minutes}:${seconds > 9 ? seconds : '0' + seconds}`;
          setEta(formattedETA); // Set the ETA state
        } else {
          console.error("Directions request failed due to " + status);
        }
      });
    };

    return () => {
      // Cleanup the script when the component unmounts
      document.body.removeChild(script);
      delete window.initMap;
    };
  }, [deviceLat, deviceLng, userLat, userLng]);

  return (
    <div>
      <div
        id="map"
        style={{
          height: "100vh", // Full height
          width: "100%", // Full width
        }}
      ></div>
      
      {eta && (
        <div style={{ position: "absolute", top: "10px", left: "10px", backgroundColor: "white", padding: "10px", borderRadius: "5px", fontSize: "18px" }}>
          Estimated Time of Arrival (ETA): {eta}
        </div>
      )}
    </div>
  );
};

export default GoogleTrafficMap;
